module.exports = __webpack_public_path__ + "static/media/Arrow left.dc23c3fa.svg";